import React from "react";
import RoleContainer from "../../../../containers/Settings/Permission/Role";

const SettingRoles = () => {
  return <RoleContainer />;
};

export default SettingRoles;
